// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const AwsEksNodeGroupTaintEffect = {
  EksNodePoolTaintEffectNoSchedule: 'NoSchedule',
  EksNodePoolTaintEffectPreferNoSchedule: 'PreferNoSchedule',
} as const;
export type AwsEksNodeGroupTaintEffect =
  (typeof AwsEksNodeGroupTaintEffect)[keyof typeof AwsEksNodeGroupTaintEffect];

export function instanceOfAwsEksNodeGroupTaintEffect(value: any): boolean {
  for (const key in AwsEksNodeGroupTaintEffect) {
    if (Object.prototype.hasOwnProperty.call(AwsEksNodeGroupTaintEffect, key)) {
      if (
        AwsEksNodeGroupTaintEffect[
          key as keyof typeof AwsEksNodeGroupTaintEffect
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function AwsEksNodeGroupTaintEffectFromJSON(
  json: any,
): AwsEksNodeGroupTaintEffect {
  return AwsEksNodeGroupTaintEffectFromJSONTyped(json, false);
}

export function AwsEksNodeGroupTaintEffectFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AwsEksNodeGroupTaintEffect {
  return json as AwsEksNodeGroupTaintEffect;
}

export function AwsEksNodeGroupTaintEffectToJSON(
  value?: AwsEksNodeGroupTaintEffect | null,
): any {
  return value as any;
}

export function AwsEksNodeGroupTaintEffectToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): AwsEksNodeGroupTaintEffect {
  return value as AwsEksNodeGroupTaintEffect;
}
